import tw, { styled } from 'twin.macro';
import { variants } from '@/components/Link/Link.styles';

export const Wrapper = styled.section`
  ${tw`bg-neutrals-n1`}
  ${tw`rounded-lg`}
  ${tw`py-4 px-2 md:px-4`}
  ${tw`border border-solid border-neutrals-n6`}
`;

export const Form = styled.form`
  ${tw`flex flex-col md:block`}
  ${tw`gap-2`}
`;

export const Label = styled.label`
  ${tw`block`}
  ${tw`font-inter`}
  ${tw`text-body-m text-neutrals-n8`}
  ${tw`font-medium`}
  ${tw`mb-1`}
`;

export const InputWrapper = styled.div`
  ${tw`col-span-12 md:col-span-9 lg:col-span-10`}
  ${tw`relative block`}
  ${tw`border-[1px] border-solid border-neutrals-n6`}
  ${tw`rounded-[6px]`}
  ${tw`w-full`}
`;

export const Input = styled.input`
  ${tw`p-[12px] md:pr-5`}
  ${tw`w-full`}
  ${tw`rounded-[6px]`}
  ${tw`outline-none`}
`;

export const IconWrapper = styled.span`
  ${tw`hidden md:block`}
  ${tw`absolute`}
  ${tw`w-[19px] h-[21px]`}
  ${tw`right-[12px] top-[12px]`}

  svg {
    ${tw`w-full`}
  }
  svg * {
    ${tw`stroke-neutrals-n7`}
  }
`;

export const Button = styled.button`
  ${variants.primary}
  ${tw`md:hidden`}
  ${tw`w-full`}
  ${tw`py-[13px]`}
`;
